import { styled } from "@mui/material/styles";
import { Typography as MuiTypography } from "@mui/material";

export const ShowDetailsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  zIndex: "1",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  padding: `${theme.space._500}`,
  gap: theme.space._500,

  "@media (max-width: 600px)": {
    padding: `${theme.space._400}`,
  },
}));

export const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._300,
}));

export const ShowNameTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["neutral.400"],
}));
